/*  
    AI Suggest Store - Actions
    These are the current events AI Suggest will kickoff.
    All events are listed below.
    TODO: future events will need to be added for the birds eye view.
*/

const AbstractionAiActions = {
    START_LOAD: "abstraction-ai/start-load",
    LOADED: "abstraction-ai/loaded",
    LOAD_ERROR: "abstraction-ai/load-error",
    FEEDBACK: "abstraction-ai/feedback",
};

export default AbstractionAiActions;



// WEBPACK FOOTER //
// ./app/data/meta/AbstractionAiActions.js